<!-- DNS Request -->
<log-cinematic-sub-section-wrapper
    *ngIf="dnsRequestInfo$ | async"
    header="{{ l10nKeys.dnsRequestLabel | vtranslate }}"
>
    <log-cinematic-sub-section-dns-request></log-cinematic-sub-section-dns-request>
</log-cinematic-sub-section-wrapper>
<!-- DNS Response -->
<log-cinematic-sub-section-wrapper
    *ngIf="dnsResponseInfo$ | async"
    header="{{ l10nKeys.dnsResponseLabel | vtranslate }}"
>
    <log-cinematic-sub-section-dns-response></log-cinematic-sub-section-dns-response>
</log-cinematic-sub-section-wrapper>
